const distributorOperations = {
  'Manage your practices and their account settings.':
    'Administre sus clínicas y la configuración de sus cuentas.',
  'Search customers...': 'Buscar clientes...',
  'New customer': 'Nuevo cliente',
  'Reload clinic': 'Volver a cargar la clínica',

  'Available product units': 'Unidades de producto disponibles',
  'Check product units': 'Calcular unidades de producto',
  'Product units, not pieces': 'Unidades de producto, no piezas',
  'Buy units': 'Comprar unidades',
  'Purchases are unavailable. Contact MedEffects.':
    'Las compras no están disponibles. Comuníquese con MedEffects.',
  'Drafts do not send funds or add units.': 'Los borradores no envían fondos ni agregan unidades.',
  'Purchase records': 'Registros de compras',
  'No purchase records yet.': 'Aún no hay registros de compras.',
  'Unit activity': 'Actividad de unidades',
  'No unit activity yet.': 'Aún no hay actividad de unidades.',
  References: 'Referencias',
  'See the product units for a selected quantity.':
    'Vea las unidades de producto para la cantidad seleccionada.',
  'Filter by date submitted (UTC)': 'Filtrar por fecha de envío (UTC)',
  'Distributor Customers': 'Clientes del distribuidor',
  'Distributor Orders': 'Pedidos del distribuidor',
  'Distributor IVRs': 'IVR del distribuidor',
  'Distributor Shipments': 'Envios del distribuidor',
  'Distributor Tissue Bank': 'Banco de tejidos del distribuidor',
  'Distributor Setup': 'Configuracion del distribuidor',
  'Distributor operations': 'Operaciones del distribuidor',
  'Choose a distributor to view its records. Direct MedEffects records are separate.':
    'Seleccione un distribuidor para ver sus registros. Los registros directos de MedEffects estan separados.',
  'Could not load distributors. Please try again.':
    'No se pudieron cargar los distribuidores. Vuelva a intentar.',
  'Loading distributors...': 'Cargando distribuidores...',
  'Choose a distributor': 'Seleccione un distribuidor',
  'Save or discard your current edits before changing distributors.':
    'Guarde o descarte sus cambios antes de cambiar de distribuidor.',
  'This distributor is unavailable. Choose a distributor from the list.':
    'Este distribuidor no esta disponible. Seleccione un distribuidor de la lista.',
  'No distributors are available.': 'No hay distribuidores disponibles.',
  'Selected distributor': 'Distribuidor seleccionado',

  'View payment support case': 'Ver caso de soporte del pago',
  'Payment status changed. Reload review records.':
    'El estado del pago ha cambiado. Recargue los registros de revisión.',
  'Checking support case...': 'Consultando caso de soporte...',
  'Original payment request reference': 'Referencia de la solicitud de pago original',
  'Recording a support case does not resolve the payment, close the purchase, retry a charge or add units. Review payment evidence separately.':
    'Registrar un caso de soporte no resuelve el pago, no cierra la compra, no reintenta un cobro ni agrega unidades. Revise la evidencia del pago por separado.',
  'Support case recorded': 'Caso de soporte registrado',
  'Provider support case reference': 'Referencia del caso de soporte del proveedor',
  'Enter only the support case reference. Do not enter bank details, credentials or provider responses.':
    'Ingrese solo la referencia del caso de soporte. No ingrese datos bancarios, credenciales ni respuestas del proveedor.',
  'Recover same support case request': 'Recuperar la misma solicitud del caso de soporte',
  'Record support case': 'Registrar caso de soporte',
  'Support case details are unavailable. Reload review records before continuing. The saved payment remains unchanged.':
    'Los detalles del caso de soporte no están disponibles. El pago guardado no ha cambiado.',
  'Support case result is unconfirmed. Recover the same case request before recording another.':
    'El resultado del caso de soporte no está confirmado. Recupere la misma solicitud antes de registrar otra.',
  'Automatic notice checks are off. Existing notices remain available.':
    'Las revisiones automáticas de avisos están desactivadas. Los avisos existentes siguen disponibles.',
  'Order release monitor health': 'Estado del monitor de liberación de órdenes',
  'Refresh order release health': 'Actualizar estado de liberación de órdenes',
  'Loading order release health...': 'Cargando estado de liberación de órdenes...',
  'Order release health is unavailable. Readiness is unconfirmed.':
    'El estado de liberación de órdenes no está disponible. No se ha confirmado que esté listo.',
  'Checks processing orders after replenishment. This view does not enable release or resend uncertain forms.':
    'Revisa las órdenes en procesamiento después de reponer el saldo. Esta vista no activa la liberación ni reenvía formularios de entrega incierta.',
  'Last successful release check': 'Última revisión de liberación correcta',
  'Oldest pending check': 'Revisión pendiente más antigua',
  'Orders awaiting checks': 'Órdenes pendientes de revisión',
  'Processing orders': 'Órdenes en procesamiento',
  'Order reviews required': 'Revisiones de órdenes necesarias',
  'Orders awaiting form delivery': 'Órdenes pendientes de envío de formularios',
  'Review processing orders and payment recovery below. Uncertain delivery forms require mailbox review.':
    'Revise las órdenes en procesamiento y la recuperación de pagos a continuación. Los formularios con envío incierto requieren revisar el buzón.',
  'Operational notices': 'Avisos operativos',
  'Refresh notices': 'Actualizar avisos',
  'Private order and payment updates for distributor users and MedEffects staff. Separate from low-bank alerts.':
    'Actualizaciones privadas de órdenes y pagos para distribuidores y personal de MedEffects. Son independientes de las alertas de saldo bajo.',
  'Loading operational notices...': 'Cargando avisos operativos...',
  'Operational notices are unavailable. Please retry.':
    'Los avisos operativos no están disponibles. Inténtelo de nuevo.',
  'Operational notice emails are enabled.': 'Los correos de avisos operativos están activados.',
  'Operational notice emails are off. In-app notices remain available.':
    'Los correos de avisos operativos están desactivados. Los avisos siguen disponibles en la aplicación.',
  'No operational notices yet.': 'Aún no hay avisos operativos.',
  'Order awaiting units': 'Orden pendiente de unidades',
  'Order review required': 'Se requiere revisar la orden',
  'Payment result unconfirmed': 'Resultado del pago sin confirmar',
  'Payment return or dispute': 'Devolución o disputa de pago',
  'An order is waiting for product units. Review the order and tissue bank.':
    'Una orden está esperando unidades de producto. Revise la orden y el banco de tejidos.',
  'An order needs distributor review before processing can continue.':
    'Una orden requiere revisión del distribuidor antes de continuar su procesamiento.',
  'A product-unit payment needs verification. Do not submit it again.':
    'Un pago de unidades de producto requiere verificación. No lo envíe de nuevo.',
  'A product-unit payment needs recovery review. Review the affected product family.':
    'Un pago de unidades de producto requiere revisión de recuperación. Revise la familia de productos afectada.',
  'This notice is resolved. Review the current record for its latest status.':
    'Este aviso está resuelto. Revise el registro actual para ver su estado más reciente.',
  'Needs attention': 'Requiere atención',
  'Notice resolved': 'Aviso resuelto',
  Recorded: 'Registrado',
  'Distributor reference': 'Referencia del distribuidor',
  'Order reference': 'Referencia de la orden',
  'Purchase reference': 'Referencia de la compra',
  'Review orders': 'Revisar órdenes',
  'Review purchases': 'Revisar compras',
  'Operational notice pages': 'Páginas de avisos operativos',
  'Operational notice email recovery': 'Recuperación de correos operativos',
  'Review interrupted private operational emails. This does not approve orders, change bank units, or submit payments.':
    'Revise correos operativos privados interrumpidos. Esto no aprueba órdenes, modifica unidades ni envía pagos.',
  'Refresh operational email queue': 'Actualizar cola de correos operativos',
  'Loading operational emails...': 'Cargando correos operativos...',
  'No operational emails need recovery.': 'No hay correos operativos que requieran recuperación.',
  'Operational notice email recovery is unavailable. Please retry.':
    'La recuperación de correos operativos no está disponible. Inténtelo de nuevo.',
  'Operational notice review was not confirmed. Refresh and check the mailbox before another decision.':
    'La revisión del aviso operativo no se confirmó. Actualice y revise el buzón antes de tomar otra decisión.',
  'Mailbox review saved. The notice is queued and can send when enabled and its recipient remains eligible.':
    'Revisión del buzón guardada. El aviso está en cola y puede enviarse cuando se active y el destinatario siga siendo elegible.',
  'Email attempt': 'Intento de correo',
  'An active or incomplete attempt cannot be reviewed yet. Wait at least 15 minutes, then refresh.':
    'Un intento activo o incompleto aún no se puede revisar. Espere al menos 15 minutos y actualice.',
  'Review operational email evidence': 'Revisar evidencia del correo operativo',
  'Confirmed not sent requeues this notice. It may send automatically after review if enabled.':
    'Confirmar que no se envió devuelve el aviso a la cola. Puede enviarse automáticamente después de la revisión si está activado.',
  'Operational email pages': 'Páginas de correos operativos',
};

export default distributorOperations;
